import axios from 'axios'
import { getApiHeader } from './../services/getApiHeaders';

export function listChannel(payload) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/channel/access',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    })
}

export function getChannelImportApi(payload) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/import/getchannelimportapi',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    })
}


// WEBPACK FOOTER //
// ./src/utils/channel.js